/**
 * Fetch with timeout and better error handling
 * Helps prevent issues with browser extensions interfering with requests
 */
export const fetchWithTimeout = async (url, options = {}, timeout = 10000) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
      // Add headers to prevent extension interference
      headers: {
        ...options.headers,
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    clearTimeout(id);
    return response;
  } catch (error) {
    clearTimeout(id);
    if (error.name === 'AbortError') {
      throw new Error('Request timeout');
    }
    // Check if error is from browser extension
    if (error.message && error.message.includes('chrome-extension://')) {
      // Retry once without the extension interfering
      return fetch(url, options);
    }
    throw error;
  }
};
export default fetchWithTimeout;
